// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================
   Wrapper & Container
   ============================================ */

.prebookings-wrapper {
  padding: 24px;
  background-color: #f5f5f5;
  min-height: calc(100vh - 64px);
}

/* ============================================
   Header
   ============================================ */

.prebookings-header-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  flex-wrap: wrap;
  gap: 16px;
}

.prebookings-header {
  font-size: 28px;
  font-weight: 600;
  color: #b71c1c;
  letter-spacing: 0.5px;
}

/* ============================================
   Button Container
   ============================================ */

.prebookings-btn-container {
  display: flex;
  gap: 12px;
  align-items: center;
}

.prebookings-bordered-button {
  border-radius: 8px !important;
  text-transform: none !important;
  font-weight: 500 !important;
  padding: 6px 16px !important;
  background: linear-gradient(135deg, #e53935 0%, #b71c1c 100%) !important;
  color: #fff !important;
  transition: all 0.3s ease !important;
}

.prebookings-bordered-button:hover {
  background: linear-gradient(135deg, #d32f2f 0%, #8e0000 100%) !important;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(183, 28, 28, 0.3) !important;
}

.prebookings-bordered-button:disabled {
  background: #e0a3a3 !important;
  cursor: not-allowed;
}

.prebookings-bordered-button:focus-visible {
  outline: 2px solid #8e0000;
  outline-offset: 2px;
}

/* ============================================
   Stats
   ============================================ */

.prebookings-stats-container {
  display: flex;
  gap: 20px;
  margin-bottom: 24px;
  flex-wrap: wrap;
}

.prebookings-stat-card {
  flex: 1 1;
  min-width: 200px;
  padding: 20px;
  border-radius: 12px !important;
  background: white !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1) !important;
  transition:
    transform 0.2s ease,
    box-shadow 0.2s ease;
}

.prebookings-stat-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.15) !important;
}

.prebookings-stat-card h6 {
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 8px;
  color: #666;
}

.prebookings-stat-card h4 {
  font-size: 32px;
  font-weight: 600;
  color: #b71c1c;
}

/* ============================================
   Filters
   ============================================ */

.prebookings-filters-container {
  background: white;
  padding: 20px;
  border-radius: 12px;
  margin-bottom: 24px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
  align-items: center;
}

/* ============================================
   Table Container
   ============================================ */

.prebookings-table-container {
  background: white;
  border-radius: 12px;
  overflow-x: auto;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

/* ============================================
   Table
   ============================================ */

.prebookings-table {
  width: 100%;
  border-collapse: collapse;
  min-width: 1200px;
}

.prebookings-table thead {
  background: linear-gradient(135deg, #e53935 0%, #b71c1c 100%);
  color: white;
}

.prebookings-table th {
  padding: 16px;
  text-align: left;
  font-weight: 600;
  font-size: 14px;
  color: white;
  border-bottom: 2px solid rgba(255, 255, 255, 0.2);
  white-space: nowrap;
}

.prebookings-table td {
  padding: 14px 16px;
  border-bottom: 1px solid #e0e0e0;
  font-size: 14px;
  color: #333;
  vertical-align: middle;
}

.prebookings-table tbody tr {
  transition: background-color 0.2s ease;
}

.prebookings-table tbody tr:hover {
  background-color: #fafafa;
}

.prebookings-table tbody tr:last-child td {
  border-bottom: none;
}

.prebookings-table .prebookings-no-data {
  text-align: center;
  padding: 60px 16px;
  background-color: #fafafa;
}

/* ============================================
   Loading
   ============================================ */

.prebookings-loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  min-height: 300px;
}

/* ============================================
   Pagination
   ============================================ */

.prebookings-pagination {
  border-top: 1px solid #e0e0e0;
  padding: 12px 16px !important;
  background-color: #fafafa;
}

/* ============================================
   Modal
   ============================================ */

.prebookings-booking-details-modal {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 90%;
  max-width: 900px;
  max-height: 85vh;
  overflow-y: auto;
  background-color: white;
  border-radius: 12px !important;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2) !important;
  animation: prebookingsModalFadeIn 0.3s ease;
}

@keyframes prebookingsModalFadeIn {
  from {
    opacity: 0;
    transform: translate(-50%, -48%) scale(0.95);
  }
  to {
    opacity: 1;
    transform: translate(-50%, -50%) scale(1);
  }
}

.prebookings-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px;
  border-bottom: 2px solid #f0f0f0;
  background: linear-gradient(135deg, #e53935 0%, #b71c1c 100%);
  border-radius: 12px 12px 0 0;
  position: sticky;
  top: 0;
  z-index: 20;
}

.prebookings-modal-header h5 {
  color: white;
  font-weight: 600;
  margin: 0;
}

.prebookings-modal-header .MuiIconButton-root {
  color: white;
  transition: transform 0.2s ease;
}

.prebookings-modal-header .MuiIconButton-root:hover {
  background-color: rgba(255, 255, 255, 0.1);
  transform: rotate(90deg);
}

.prebookings-modal-content {
  padding: 24px;
}

/* ============================================
   Details Sections
   ============================================ */

.prebookings-details-section {
  margin-bottom: 28px;
  padding-bottom: 20px;
  border-bottom: 1px solid #e8e8e8;
}

.prebookings-details-section:last-child {
  border-bottom: none;
  margin-bottom: 0;
  padding-bottom: 0;
}

.prebookings-details-section h6 {
  font-size: 18px;
  font-weight: 600;
  color: #b71c1c;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.prebookings-details-section h6::before {
  content: "";
  width: 4px;
  height: 20px;
  background: linear-gradient(135deg, #e53935 0%, #b71c1c 100%);
  border-radius: 2px;
  display: inline-block;
}

.prebookings-details-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 16px;
}

.prebookings-details-grid div {
  font-size: 14px;
  line-height: 1.6;
  color: #555;
  padding: 4px 0;
}

.prebookings-details-grid strong {
  color: #333;
  font-weight: 600;
  margin-right: 8px;
}

/* ============================================
   Scoped MUI overrides — table only
   ============================================ */

.prebookings-table .MuiChip-root {
  border-radius: 20px;
  font-weight: 500;
  font-size: 12px;
  height: 24px;
  transition: all 0.2s ease;
}

.prebookings-table .MuiChip-root:hover {
  transform: scale(1.05);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.prebookings-table .MuiIconButton-root {
  padding: 6px;
  transition: all 0.2s ease;
}

.prebookings-table .MuiIconButton-root:hover {
  transform: scale(1.1);
  background-color: rgba(183, 28, 28, 0.1) !important;
}

.prebookings-table .MuiIconButton-root .MuiSvgIcon-root {
  font-size: 20px;
}

/* ============================================
   Scoped MUI overrides — filters only
   ============================================ */

.prebookings-filters-container .MuiSelect-select {
  font-size: 13px !important;
  padding: 6px 12px !important;
}

.prebookings-filters-container .MuiInputLabel-root {
  font-size: 13px;
}

.prebookings-filters-container .Mui-focused .MuiOutlinedInput-notchedOutline {
  border-color: #b71c1c !important;
}

.prebookings-filters-container .MuiInputLabel-root.Mui-focused {
  color: #b71c1c !important;
}

/* ============================================
   Scoped MUI overrides — snackbar only
   ============================================ */

.prebookings-snackbar .MuiAlert-root {
  border-radius: 8px !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
  min-width: 300px;
}

.prebookings-snackbar .MuiAlert-standardSuccess {
  background-color: #e8f5e9 !important;
  color: #1b5e20 !important;
}

.prebookings-snackbar .MuiAlert-standardError {
  background-color: #ffebee !important;
  color: #c62828 !important;
}

.prebookings-snackbar .MuiAlert-standardWarning {
  background-color: #fff3e0 !important;
  color: #e65100 !important;
}

.prebookings-snackbar .MuiAlert-standardInfo {
  background-color: #e3f2fd !important;
  color: #0d47a1 !important;
}

/* ============================================
   Scrollbars
   ============================================ */

.prebookings-booking-details-modal::-webkit-scrollbar {
  width: 8px;
}

.prebookings-booking-details-modal::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

.prebookings-booking-details-modal::-webkit-scrollbar-thumb {
  background: #b71c1c;
  border-radius: 4px;
}

.prebookings-booking-details-modal::-webkit-scrollbar-thumb:hover {
  background: #8e0000;
}

.prebookings-table-container::-webkit-scrollbar {
  height: 8px;
}

.prebookings-table-container::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

.prebookings-table-container::-webkit-scrollbar-thumb {
  background: #b71c1c;
  border-radius: 4px;
}

.prebookings-table-container::-webkit-scrollbar-thumb:hover {
  background: #8e0000;
}

/* ============================================
   Responsive
   ============================================ */

@media (max-width: 1024px) {
  .prebookings-table {
    min-width: 1000px;
  }

  .prebookings-filters-container {
    flex-direction: row;
    flex-wrap: wrap;
  }

  .prebookings-filters-container .MuiTextField-root {
    min-width: 200px;
    flex: 1 1;
  }

  .prebookings-filters-container .MuiFormControl-root {
    min-width: 150px;
  }
}

@media (max-width: 768px) {
  .prebookings-wrapper {
    padding: 16px;
  }

  .prebookings-header {
    font-size: 24px;
  }

  .prebookings-stats-container {
    flex-direction: column;
  }

  .prebookings-stat-card {
    min-width: auto;
    padding: 16px;
  }

  .prebookings-stat-card h4 {
    font-size: 28px;
  }

  .prebookings-filters-container {
    flex-direction: column;
    padding: 16px;
  }

  .prebookings-filters-container .MuiTextField-root,
  .prebookings-filters-container .MuiFormControl-root {
    width: 100% !important;
    min-width: auto !important;
  }

  .prebookings-booking-details-modal {
    width: 95%;
    max-height: 90vh;
  }

  .prebookings-details-grid {
    grid-template-columns: 1fr;
    gap: 12px;
  }

  .prebookings-modal-header {
    padding: 16px;
  }

  .prebookings-modal-content {
    padding: 16px;
  }

  .prebookings-modal-header h5 {
    font-size: 20px;
  }

  .prebookings-details-section h6 {
    font-size: 16px;
  }

  .prebookings-table th,
  .prebookings-table td {
    padding: 10px 12px;
    font-size: 13px;
  }

  .prebookings-table .MuiChip-root {
    font-size: 11px;
    height: 20px;
  }

  .prebookings-table .MuiIconButton-root .MuiSvgIcon-root {
    font-size: 18px;
  }

  .prebookings-pagination {
    padding: 8px 12px !important;
  }
}

@media (max-width: 480px) {
  .prebookings-wrapper {
    padding: 12px;
  }

  .prebookings-header {
    font-size: 20px;
  }

  .prebookings-header-container {
    flex-direction: column;
    align-items: stretch;
    gap: 12px;
  }

  .prebookings-btn-container {
    justify-content: stretch;
  }

  .prebookings-btn-container .prebookings-bordered-button {
    width: 100%;
  }

  .prebookings-stat-card h4 {
    font-size: 24px;
  }

  .prebookings-booking-details-modal {
    width: 98%;
    max-height: 95vh;
  }

  .prebookings-modal-header {
    padding: 12px 16px;
  }

  .prebookings-modal-header h5 {
    font-size: 18px;
  }

  .prebookings-modal-content {
    padding: 12px;
  }

  .prebookings-details-grid div {
    font-size: 13px;
  }

  .prebookings-table th,
  .prebookings-table td {
    padding: 8px 10px;
    font-size: 12px;
  }

  .prebookings-table-container {
    border-radius: 8px;
  }

  .prebookings-filters-container {
    padding: 12px;
  }
}

/* ============================================
   Print
   ============================================ */

@media print {
  .prebookings-header-container,
  .prebookings-stats-container,
  .prebookings-filters-container,
  .prebookings-pagination,
  .prebookings-modal-header .MuiIconButton-root {
    display: none !important;
  }

  .prebookings-booking-details-modal {
    position: static;
    transform: none;
    width: 100%;
    max-height: none;
    box-shadow: none;
    border: 1px solid #ddd;
    border-radius: 4px !important;
  }

  .prebookings-details-section {
    break-inside: avoid;
    page-break-inside: avoid;
  }

  .prebookings-table {
    min-width: auto;
  }

  .prebookings-table thead,
  .prebookings-table th,
  .prebookings-modal-header {
    background: #b71c1c !important;
    print-color-adjust: exact;
  }

  .prebookings-stat-card {
    box-shadow: none !important;
    border: 1px solid #ddd;
  }
}

/* ============================================
   Accessibility
   ============================================ */

.prebookings-table th:focus-visible,
.prebookings-table td:focus-visible {
  outline: 2px solid #b71c1c;
  outline-offset: -2px;
}

@media (forced-colors: active) {
  .prebookings-table thead,
  .prebookings-table th,
  .prebookings-modal-header {
    background: CanvasText !important;
    color: Canvas !important;
  }

  .prebookings-modal-header h5 {
    color: Canvas !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/features/PreBookings/PreBookings.css"],"names":[],"mappings":"AAAA;;iDAEiD;;AAEjD;EACE,aAAa;EACb,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;;iDAEiD;;AAEjD;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA;;iDAEiD;;AAEjD;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,+BAA+B;EAC/B,2BAA2B;EAC3B,4BAA4B;EAC5B,wEAAwE;EACxE,sBAAsB;EACtB,oCAAoC;AACtC;;AAEA;EACE,wEAAwE;EACxE,2BAA2B;EAC3B,wDAAwD;AAC1D;;AAEA;EACE,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;;iDAEiD;;AAEjD;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;EACb,8BAA8B;EAC9B,4BAA4B;EAC5B,mDAAmD;EACnD;;wBAEsB;AACxB;;AAEA;EACE,2BAA2B;EAC3B,qDAAqD;AACvD;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;iDAEiD;;AAEjD;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,wCAAwC;EACxC,aAAa;EACb,SAAS;EACT,eAAe;EACf,mBAAmB;AACrB;;AAEA;;iDAEiD;;AAEjD;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA;;iDAEiD;;AAEjD;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;AACd;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,iDAAiD;EACjD,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,eAAe;EACf,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;;iDAEiD;;AAEjD;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;;iDAEiD;;AAEjD;EACE,6BAA6B;EAC7B,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;;iDAEiD;;AAEjD;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,8BAA8B;EAC9B,qDAAqD;EACrD,2CAA2C;AAC7C;;AAEA;EACE;IACE,UAAU;IACV,4CAA4C;EAC9C;EACA;IACE,UAAU;IACV,yCAAyC;EAC3C;AACF;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;EAChC,6DAA6D;EAC7D,4BAA4B;EAC5B,gBAAgB;EAChB,MAAM;EACN,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,+BAA+B;AACjC;;AAEA;EACE,0CAA0C;EAC1C,wBAAwB;AAC1B;;AAEA;EACE,aAAa;AACf;;AAEA;;iDAEiD;;AAEjD;EACE,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,UAAU;EACV,YAAY;EACZ,6DAA6D;EAC7D,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;;iDAEiD;;AAEjD;EACE,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,yCAAyC;AAC3C;;AAEA;EACE,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,mDAAmD;AACrD;;AAEA;EACE,eAAe;AACjB;;AAEA;;iDAEiD;;AAEjD;EACE,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;iDAEiD;;AAEjD;EACE,6BAA6B;EAC7B,qDAAqD;EACrD,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;;iDAEiD;;AAEjD;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;iDAEiD;;AAEjD;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,SAAO;EACT;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,eAAe;IACf,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,aAAa;EACf;;EAEA;;IAEE,sBAAsB;IACtB,0BAA0B;EAC5B;;EAEA;IACE,UAAU;IACV,gBAAgB;EAClB;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;IACpB,SAAS;EACX;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,UAAU;IACV,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;;iDAEiD;;AAEjD;EACE;;;;;IAKE,wBAAwB;EAC1B;;EAEA;IACE,gBAAgB;IAChB,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB,sBAAsB;IACtB,6BAA6B;EAC/B;;EAEA;IACE,mBAAmB;IACnB,wBAAwB;EAC1B;;EAEA;IACE,eAAe;EACjB;;EAEA;;;IAGE,8BAA8B;IAE9B,yBAAyB;EAC3B;;EAEA;IACE,2BAA2B;IAC3B,sBAAsB;EACxB;AACF;;AAEA;;iDAEiD;;AAEjD;;EAEE,0BAA0B;EAC1B,oBAAoB;AACtB;;AAEA;EACE;;;IAGE,iCAAiC;IACjC,wBAAwB;EAC1B;;EAEA;IACE,wBAAwB;EAC1B;AACF","sourcesContent":["/* ============================================\n   Wrapper & Container\n   ============================================ */\n\n.prebookings-wrapper {\n  padding: 24px;\n  background-color: #f5f5f5;\n  min-height: calc(100vh - 64px);\n}\n\n/* ============================================\n   Header\n   ============================================ */\n\n.prebookings-header-container {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 24px;\n  flex-wrap: wrap;\n  gap: 16px;\n}\n\n.prebookings-header {\n  font-size: 28px;\n  font-weight: 600;\n  color: #b71c1c;\n  letter-spacing: 0.5px;\n}\n\n/* ============================================\n   Button Container\n   ============================================ */\n\n.prebookings-btn-container {\n  display: flex;\n  gap: 12px;\n  align-items: center;\n}\n\n.prebookings-bordered-button {\n  border-radius: 8px !important;\n  text-transform: none !important;\n  font-weight: 500 !important;\n  padding: 6px 16px !important;\n  background: linear-gradient(135deg, #e53935 0%, #b71c1c 100%) !important;\n  color: #fff !important;\n  transition: all 0.3s ease !important;\n}\n\n.prebookings-bordered-button:hover {\n  background: linear-gradient(135deg, #d32f2f 0%, #8e0000 100%) !important;\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(183, 28, 28, 0.3) !important;\n}\n\n.prebookings-bordered-button:disabled {\n  background: #e0a3a3 !important;\n  cursor: not-allowed;\n}\n\n.prebookings-bordered-button:focus-visible {\n  outline: 2px solid #8e0000;\n  outline-offset: 2px;\n}\n\n/* ============================================\n   Stats\n   ============================================ */\n\n.prebookings-stats-container {\n  display: flex;\n  gap: 20px;\n  margin-bottom: 24px;\n  flex-wrap: wrap;\n}\n\n.prebookings-stat-card {\n  flex: 1;\n  min-width: 200px;\n  padding: 20px;\n  border-radius: 12px !important;\n  background: white !important;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1) !important;\n  transition:\n    transform 0.2s ease,\n    box-shadow 0.2s ease;\n}\n\n.prebookings-stat-card:hover {\n  transform: translateY(-4px);\n  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.15) !important;\n}\n\n.prebookings-stat-card h6 {\n  font-size: 14px;\n  font-weight: 500;\n  margin-bottom: 8px;\n  color: #666;\n}\n\n.prebookings-stat-card h4 {\n  font-size: 32px;\n  font-weight: 600;\n  color: #b71c1c;\n}\n\n/* ============================================\n   Filters\n   ============================================ */\n\n.prebookings-filters-container {\n  background: white;\n  padding: 20px;\n  border-radius: 12px;\n  margin-bottom: 24px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  display: flex;\n  gap: 16px;\n  flex-wrap: wrap;\n  align-items: center;\n}\n\n/* ============================================\n   Table Container\n   ============================================ */\n\n.prebookings-table-container {\n  background: white;\n  border-radius: 12px;\n  overflow-x: auto;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n}\n\n/* ============================================\n   Table\n   ============================================ */\n\n.prebookings-table {\n  width: 100%;\n  border-collapse: collapse;\n  min-width: 1200px;\n}\n\n.prebookings-table thead {\n  background: linear-gradient(135deg, #e53935 0%, #b71c1c 100%);\n  color: white;\n}\n\n.prebookings-table th {\n  padding: 16px;\n  text-align: left;\n  font-weight: 600;\n  font-size: 14px;\n  color: white;\n  border-bottom: 2px solid rgba(255, 255, 255, 0.2);\n  white-space: nowrap;\n}\n\n.prebookings-table td {\n  padding: 14px 16px;\n  border-bottom: 1px solid #e0e0e0;\n  font-size: 14px;\n  color: #333;\n  vertical-align: middle;\n}\n\n.prebookings-table tbody tr {\n  transition: background-color 0.2s ease;\n}\n\n.prebookings-table tbody tr:hover {\n  background-color: #fafafa;\n}\n\n.prebookings-table tbody tr:last-child td {\n  border-bottom: none;\n}\n\n.prebookings-table .prebookings-no-data {\n  text-align: center;\n  padding: 60px 16px;\n  background-color: #fafafa;\n}\n\n/* ============================================\n   Loading\n   ============================================ */\n\n.prebookings-loading-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 60px 20px;\n  min-height: 300px;\n}\n\n/* ============================================\n   Pagination\n   ============================================ */\n\n.prebookings-pagination {\n  border-top: 1px solid #e0e0e0;\n  padding: 12px 16px !important;\n  background-color: #fafafa;\n}\n\n/* ============================================\n   Modal\n   ============================================ */\n\n.prebookings-booking-details-modal {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 90%;\n  max-width: 900px;\n  max-height: 85vh;\n  overflow-y: auto;\n  background-color: white;\n  border-radius: 12px !important;\n  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2) !important;\n  animation: prebookingsModalFadeIn 0.3s ease;\n}\n\n@keyframes prebookingsModalFadeIn {\n  from {\n    opacity: 0;\n    transform: translate(-50%, -48%) scale(0.95);\n  }\n  to {\n    opacity: 1;\n    transform: translate(-50%, -50%) scale(1);\n  }\n}\n\n.prebookings-modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 20px 24px;\n  border-bottom: 2px solid #f0f0f0;\n  background: linear-gradient(135deg, #e53935 0%, #b71c1c 100%);\n  border-radius: 12px 12px 0 0;\n  position: sticky;\n  top: 0;\n  z-index: 20;\n}\n\n.prebookings-modal-header h5 {\n  color: white;\n  font-weight: 600;\n  margin: 0;\n}\n\n.prebookings-modal-header .MuiIconButton-root {\n  color: white;\n  transition: transform 0.2s ease;\n}\n\n.prebookings-modal-header .MuiIconButton-root:hover {\n  background-color: rgba(255, 255, 255, 0.1);\n  transform: rotate(90deg);\n}\n\n.prebookings-modal-content {\n  padding: 24px;\n}\n\n/* ============================================\n   Details Sections\n   ============================================ */\n\n.prebookings-details-section {\n  margin-bottom: 28px;\n  padding-bottom: 20px;\n  border-bottom: 1px solid #e8e8e8;\n}\n\n.prebookings-details-section:last-child {\n  border-bottom: none;\n  margin-bottom: 0;\n  padding-bottom: 0;\n}\n\n.prebookings-details-section h6 {\n  font-size: 18px;\n  font-weight: 600;\n  color: #b71c1c;\n  margin-bottom: 16px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.prebookings-details-section h6::before {\n  content: \"\";\n  width: 4px;\n  height: 20px;\n  background: linear-gradient(135deg, #e53935 0%, #b71c1c 100%);\n  border-radius: 2px;\n  display: inline-block;\n}\n\n.prebookings-details-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));\n  gap: 16px;\n}\n\n.prebookings-details-grid div {\n  font-size: 14px;\n  line-height: 1.6;\n  color: #555;\n  padding: 4px 0;\n}\n\n.prebookings-details-grid strong {\n  color: #333;\n  font-weight: 600;\n  margin-right: 8px;\n}\n\n/* ============================================\n   Scoped MUI overrides — table only\n   ============================================ */\n\n.prebookings-table .MuiChip-root {\n  border-radius: 20px;\n  font-weight: 500;\n  font-size: 12px;\n  height: 24px;\n  transition: all 0.2s ease;\n}\n\n.prebookings-table .MuiChip-root:hover {\n  transform: scale(1.05);\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);\n}\n\n.prebookings-table .MuiIconButton-root {\n  padding: 6px;\n  transition: all 0.2s ease;\n}\n\n.prebookings-table .MuiIconButton-root:hover {\n  transform: scale(1.1);\n  background-color: rgba(183, 28, 28, 0.1) !important;\n}\n\n.prebookings-table .MuiIconButton-root .MuiSvgIcon-root {\n  font-size: 20px;\n}\n\n/* ============================================\n   Scoped MUI overrides — filters only\n   ============================================ */\n\n.prebookings-filters-container .MuiSelect-select {\n  font-size: 13px !important;\n  padding: 6px 12px !important;\n}\n\n.prebookings-filters-container .MuiInputLabel-root {\n  font-size: 13px;\n}\n\n.prebookings-filters-container .Mui-focused .MuiOutlinedInput-notchedOutline {\n  border-color: #b71c1c !important;\n}\n\n.prebookings-filters-container .MuiInputLabel-root.Mui-focused {\n  color: #b71c1c !important;\n}\n\n/* ============================================\n   Scoped MUI overrides — snackbar only\n   ============================================ */\n\n.prebookings-snackbar .MuiAlert-root {\n  border-radius: 8px !important;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;\n  min-width: 300px;\n}\n\n.prebookings-snackbar .MuiAlert-standardSuccess {\n  background-color: #e8f5e9 !important;\n  color: #1b5e20 !important;\n}\n\n.prebookings-snackbar .MuiAlert-standardError {\n  background-color: #ffebee !important;\n  color: #c62828 !important;\n}\n\n.prebookings-snackbar .MuiAlert-standardWarning {\n  background-color: #fff3e0 !important;\n  color: #e65100 !important;\n}\n\n.prebookings-snackbar .MuiAlert-standardInfo {\n  background-color: #e3f2fd !important;\n  color: #0d47a1 !important;\n}\n\n/* ============================================\n   Scrollbars\n   ============================================ */\n\n.prebookings-booking-details-modal::-webkit-scrollbar {\n  width: 8px;\n}\n\n.prebookings-booking-details-modal::-webkit-scrollbar-track {\n  background: #f1f1f1;\n  border-radius: 4px;\n}\n\n.prebookings-booking-details-modal::-webkit-scrollbar-thumb {\n  background: #b71c1c;\n  border-radius: 4px;\n}\n\n.prebookings-booking-details-modal::-webkit-scrollbar-thumb:hover {\n  background: #8e0000;\n}\n\n.prebookings-table-container::-webkit-scrollbar {\n  height: 8px;\n}\n\n.prebookings-table-container::-webkit-scrollbar-track {\n  background: #f1f1f1;\n  border-radius: 4px;\n}\n\n.prebookings-table-container::-webkit-scrollbar-thumb {\n  background: #b71c1c;\n  border-radius: 4px;\n}\n\n.prebookings-table-container::-webkit-scrollbar-thumb:hover {\n  background: #8e0000;\n}\n\n/* ============================================\n   Responsive\n   ============================================ */\n\n@media (max-width: 1024px) {\n  .prebookings-table {\n    min-width: 1000px;\n  }\n\n  .prebookings-filters-container {\n    flex-direction: row;\n    flex-wrap: wrap;\n  }\n\n  .prebookings-filters-container .MuiTextField-root {\n    min-width: 200px;\n    flex: 1;\n  }\n\n  .prebookings-filters-container .MuiFormControl-root {\n    min-width: 150px;\n  }\n}\n\n@media (max-width: 768px) {\n  .prebookings-wrapper {\n    padding: 16px;\n  }\n\n  .prebookings-header {\n    font-size: 24px;\n  }\n\n  .prebookings-stats-container {\n    flex-direction: column;\n  }\n\n  .prebookings-stat-card {\n    min-width: auto;\n    padding: 16px;\n  }\n\n  .prebookings-stat-card h4 {\n    font-size: 28px;\n  }\n\n  .prebookings-filters-container {\n    flex-direction: column;\n    padding: 16px;\n  }\n\n  .prebookings-filters-container .MuiTextField-root,\n  .prebookings-filters-container .MuiFormControl-root {\n    width: 100% !important;\n    min-width: auto !important;\n  }\n\n  .prebookings-booking-details-modal {\n    width: 95%;\n    max-height: 90vh;\n  }\n\n  .prebookings-details-grid {\n    grid-template-columns: 1fr;\n    gap: 12px;\n  }\n\n  .prebookings-modal-header {\n    padding: 16px;\n  }\n\n  .prebookings-modal-content {\n    padding: 16px;\n  }\n\n  .prebookings-modal-header h5 {\n    font-size: 20px;\n  }\n\n  .prebookings-details-section h6 {\n    font-size: 16px;\n  }\n\n  .prebookings-table th,\n  .prebookings-table td {\n    padding: 10px 12px;\n    font-size: 13px;\n  }\n\n  .prebookings-table .MuiChip-root {\n    font-size: 11px;\n    height: 20px;\n  }\n\n  .prebookings-table .MuiIconButton-root .MuiSvgIcon-root {\n    font-size: 18px;\n  }\n\n  .prebookings-pagination {\n    padding: 8px 12px !important;\n  }\n}\n\n@media (max-width: 480px) {\n  .prebookings-wrapper {\n    padding: 12px;\n  }\n\n  .prebookings-header {\n    font-size: 20px;\n  }\n\n  .prebookings-header-container {\n    flex-direction: column;\n    align-items: stretch;\n    gap: 12px;\n  }\n\n  .prebookings-btn-container {\n    justify-content: stretch;\n  }\n\n  .prebookings-btn-container .prebookings-bordered-button {\n    width: 100%;\n  }\n\n  .prebookings-stat-card h4 {\n    font-size: 24px;\n  }\n\n  .prebookings-booking-details-modal {\n    width: 98%;\n    max-height: 95vh;\n  }\n\n  .prebookings-modal-header {\n    padding: 12px 16px;\n  }\n\n  .prebookings-modal-header h5 {\n    font-size: 18px;\n  }\n\n  .prebookings-modal-content {\n    padding: 12px;\n  }\n\n  .prebookings-details-grid div {\n    font-size: 13px;\n  }\n\n  .prebookings-table th,\n  .prebookings-table td {\n    padding: 8px 10px;\n    font-size: 12px;\n  }\n\n  .prebookings-table-container {\n    border-radius: 8px;\n  }\n\n  .prebookings-filters-container {\n    padding: 12px;\n  }\n}\n\n/* ============================================\n   Print\n   ============================================ */\n\n@media print {\n  .prebookings-header-container,\n  .prebookings-stats-container,\n  .prebookings-filters-container,\n  .prebookings-pagination,\n  .prebookings-modal-header .MuiIconButton-root {\n    display: none !important;\n  }\n\n  .prebookings-booking-details-modal {\n    position: static;\n    transform: none;\n    width: 100%;\n    max-height: none;\n    box-shadow: none;\n    border: 1px solid #ddd;\n    border-radius: 4px !important;\n  }\n\n  .prebookings-details-section {\n    break-inside: avoid;\n    page-break-inside: avoid;\n  }\n\n  .prebookings-table {\n    min-width: auto;\n  }\n\n  .prebookings-table thead,\n  .prebookings-table th,\n  .prebookings-modal-header {\n    background: #b71c1c !important;\n    -webkit-print-color-adjust: exact;\n    print-color-adjust: exact;\n  }\n\n  .prebookings-stat-card {\n    box-shadow: none !important;\n    border: 1px solid #ddd;\n  }\n}\n\n/* ============================================\n   Accessibility\n   ============================================ */\n\n.prebookings-table th:focus-visible,\n.prebookings-table td:focus-visible {\n  outline: 2px solid #b71c1c;\n  outline-offset: -2px;\n}\n\n@media (forced-colors: active) {\n  .prebookings-table thead,\n  .prebookings-table th,\n  .prebookings-modal-header {\n    background: CanvasText !important;\n    color: Canvas !important;\n  }\n\n  .prebookings-modal-header h5 {\n    color: Canvas !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
